import {NgModule} from '@angular/core';
import {UsersRoutingModule} from './users-routing.module';
import {UsersListComponent} from './users-list/users-list.component';
import {UserFormComponent} from './user-form/user-form.component';
import {UsersLayoutComponent} from './users-layout/users-layout.component';
import {RouterModule} from '@angular/router';
import {ReactiveFormsModule} from '@angular/forms';
import {FormFieldModule} from '@components/form-field/form-field.module';
import {CommonModule} from '@angular/common';
import {LayoutModule} from '@layoutComponents/layout.module';
import {UsersApiService} from './services/users.api.service';
import {UsersResolver} from './services/users.resolver';
import {UserRoleFormComponent} from './user-role-form/user-role-form.component';
import {SharedModule} from '@helpers/modules/shared.module';
import {NotForCurrentUserGuardService} from './services/not-for-current-user.guard.service';
import {IconsModule} from '@lab365/icons';

@NgModule({
    imports: [
        ReactiveFormsModule,
        FormFieldModule,
        CommonModule,
        LayoutModule,
        SharedModule,
        RouterModule,
        UsersRoutingModule,
        IconsModule,
    ],
    exports: [],
    declarations: [
        UsersLayoutComponent,
        UsersListComponent,
        UserFormComponent,
        UserRoleFormComponent,
    ],
    providers: [
        UsersApiService,
        UsersResolver,
        NotForCurrentUserGuardService,
    ],
})
export class UsersModule {

}
